import { useQuery } from '@tanstack/react-query';
import {
    requestArticleById,
    requestArticles,
    requestArticlesByCategory,
    requestCategories,
    requestCategoryById,
    requestSearchArticles,
} from '../help/help';

// Categories
export function useGetAllCategories() {
    return useQuery({
        queryKey: ['helpCategories'],
        queryFn: async ({ signal }) => (await requestCategories(signal))?.data,
    });
}

export function useGetCategoryById(id: number) {
    return useQuery({
        queryKey: ['helpCategory', id],
        queryFn: async ({ signal }) => (await requestCategoryById(id, signal))?.data,
    });
}

// Articles
export function useGetAllArticles() {
    return useQuery({
        queryKey: ['helpArticles'],
        queryFn: async ({ signal }) => (await requestArticles(signal))?.data,
    });
}

export function useGetAllArticlesByCategory(categoryId: number) {
    return useQuery({
        queryKey: ['helpArticles', `category-${categoryId}`],
        queryFn: async ({ signal }) => (await requestArticlesByCategory(categoryId, signal))?.data,
    });
}

export function useGetArticleById(articleId: number) {
    return useQuery({
        queryKey: ['helpArticle', articleId],
        queryFn: async ({ signal }) => (await requestArticleById(articleId, signal))?.data,
    });
}

export function useSearchArticles(search: string) {
    return useQuery({
        queryKey: ['helpArticleSearch', search],
        queryFn: async ({ signal }) => (await requestSearchArticles(search, signal))?.data,
    });
}
